export function getPlaceDetails(placeId, fields = ['geometry']) {
    return new Promise((resolve, reject) => {
        const svc = new window.google.maps.places.PlacesService(
            document.createElement('div')
        );
        svc.getDetails(
            { placeId, fields },
            (placeResult, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    resolve(placeResult);
                } else {
                    reject(new Error('PlacesServiceStatus: ' + status));
                }
            }
        );
    });
}
